import useMediaView from "features/common/hooks/useMediaView";
import NoticeDashboardEditMobilePage from "./(mobile)";
import React from "react";
import NoticeDashboardEditWebPage from "./(web)";

const NoticeDashboardEditPage = () => {
  const isSmall = useMediaView("small");

  return (
    <div>
      {isSmall ? (
        <NoticeDashboardEditMobilePage />
      ) : (
        <NoticeDashboardEditWebPage />
      )}
    </div>
  );
};

export default NoticeDashboardEditPage;
